'use strict';

export const PROJECT_MILESTONE_LIST_NAME = 'projectMilestoneList';
export const PROJECT_MILESTONE_LIST_PREFIX = `@@${PROJECT_MILESTONE_LIST_NAME}`;

export const TEMPLATE_MILESTONE_LIST_NAME = 'templateMilestoneList';
export const TEMPLATE_MILESTONE_LIST_PREFIX = `@@${TEMPLATE_MILESTONE_LIST_NAME}`;

export const CREATE_MILESTONE_NAME = 'createMilestone';
export const CREATE_MILESTONE_PREFIX = `@@${CREATE_MILESTONE_NAME}`;

export const UPDATE_MILESTONE_NAME = 'updateMilestone';
export const UPDATE_MILESTONE_PREFIX = `@@${UPDATE_MILESTONE_NAME}`;



// WEBPACK FOOTER //
// ./src/js/milestones/redux/state.js